export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-22.jpg'),
        title: 'Intelligent Manufacturing',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'Intelligent Manufacturing',
      description: `<p>Fifteen-Year Planning as the Beacon, Intelligent Manufacturing as the Dream! From industrial foundation-building to innovation breakthroughs, China's series of Five-Year Plans have consistently charted the course toward advanced manufacturing, paving the way for the nation’s ambitious journey to become a manufacturing powerhouse. Keeping pace with national policies, we have deeply integrated intelligent manufacturing into our development framework, harnessing 5G, AI, and the Industrial Internet to break down data barriers across R&D, production, and supply chains.</p>
      <p>Here, digital twins shorten product development cycles, smart production lines boost efficiency by over 33%, green intelligent manufacturing significantly reduces energy consumption, and flexible manufacturing precisely responds to every customized demand. From intelligent inspection on the shop floor to supply chain collaboration, from breakthroughs in key technologies to building an industrial ecosystem, we leverage policy as our sail and technology as our oar, grounding the transformation from "Made in China" to "Intelligently Made in China" and turning strategic blueprints into tangible outcomes of quality improvement and efficiency gains.</p>
      <p>In sync with the times and aligned with national strategies, we empower enterprises with the force of intelligent manufacturing, guiding them toward the mid-to-high end of the value chain and jointly writing a new chapter in advanced manufacturing.</p>`
    },
    {
      title: 'OUR ADVANTAGE',
      description: `
      <video autoplay muted loop playsinline class="advantage-video">
        <source src="https://tfile.melinked.com/2024/02/8c437d9e-7822-422c-becf-8f050d005a11.mp4" type="video/mp4">
      </video>
      <span class="list">
      <i></i>High degree of automation, significantly enhancing production efficiency.<br/>
      <i></i>Data-driven decision-making, improving operational precision.<br/>
      <i></i>Visualized production processes, facilitating real-time monitoring and management.<br/>
      <i></i>Interconnected equipment enabling flexible production and rapid response.<br/>
      <i></i>Intelligent quality inspection, reducing defect rates.<br/>
      <i></i>Optimized energy consumption, achieving green and low-carbon production.<br/>
      <i></i>Reduced reliance on labor, enhancing overall operational stability.<br/>
      </span>`
    }
  ]
}
